import {Arr, Bool, Obj, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

export const TV_SYNOPSIS_LANGUAGES = [
  {value: 'fr', label: 'Français'},
  {value: 'en', label: 'English'},
] as const;
export type TvSynopsisLanguage = (typeof TV_SYNOPSIS_LANGUAGES)[number]['value'];
export const DEFAULT_SYNOPSIS_LANGUAGE: TvSynopsisLanguage = 'en';
export function isTvSynopsisLanguage(value: unknown): value is TvSynopsisLanguage {
  return value === 'en' || value === 'fr';
}
const PreferencesSchema = Obj({preferredSynopsisLanguage: Str<TvSynopsisLanguage>()});
const SynopsisSchema = Obj({
  overview: Str(),
  language: Str<TvSynopsisLanguage>(),
  fallback: Bool(),
});
export type TvSynopsis = SchemaToType<typeof SynopsisSchema>;
export const TV_SYNOPSIS_BATCH_SIZE = 12;
export interface TvSynopsisMovie {
  imdbId?: string;
  tmdbId?: number;
}

// Separate responses preserve compatibility with installed clients' strict account schemas.
export const TV_SYNOPSIS_API = {
  '/account/synopsis-preferences': {POST: {req: Obj({}), res: PreferencesSchema}},
  '/account/synopsis-preferences/update': {
    POST: {req: PreferencesSchema, res: PreferencesSchema},
  },
  '/catalogue/synopsis': {
    POST: {req: Obj({imdbId: OptStr(), tmdbId: OptNum()}), res: SynopsisSchema},
  },
  '/catalogue/synopses': {
    POST: {
      req: Obj({imdbIds: Arr(Str())}),
      res: Obj({
        synopses: Arr(Obj({imdbId: Str(), ...SynopsisSchema.properties})),
        failedImdbIds: Arr(Str()),
      }),
    },
  },
};
